type RedirectSearchParams = Record<string, string | boolean>;

type CarriedParams = {
  deeplinkCoupon?: string | null;
  zipCode?: string | null;
  /** HL-11357: the care_plus=1 marker from the URL, when this registration is part of a Care+ funnel. */
  carePlusMarker?: string | null;
};

/**
 * Builds the query string for wherever registration forwards to.
 *
 * Registration is a hop in the middle of a funnel, so params that identify the funnel have to
 * survive it. The caller's own params win; this only adds the ones the page is responsible for
 * carrying. Returns a new object rather than mutating what the caller passed in.
 */
export const buildRedirectSearch = (
  extraParams: RedirectSearchParams = {},
  { deeplinkCoupon, zipCode, carePlusMarker }: CarriedParams = {},
): RedirectSearchParams => {
  const params: RedirectSearchParams = { ...extraParams };

  if (deeplinkCoupon) {
    params.cpn = deeplinkCoupon;
  }

  if (zipCode) {
    params.zipcode = zipCode;
  }

  // HL-11357: a Care+ one-time / prescription-only order has no plan fee for ShippingV2 to key
  // off of, so it is identified by this marker alone. Drop it and Shipping renders the default
  // layout instead of the Care+ one.
  if (carePlusMarker) {
    params.care_plus = carePlusMarker;
  }

  return params;
};
